import { render, staticRenderFns } from "./KnownMethodDelete.vue?vue&type=template&id=06d7b38a&"
import script from "./KnownMethodDelete.vue?vue&type=script&lang=js&"
export * from "./KnownMethodDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports